// extracted by mini-css-extract-plugin
export default {"detailContainer":"shipmentPreparationList_detailContainer__Ux6rv","tableContainer":"shipmentPreparationList_tableContainer__5n7oO"};